import React from "react";
import { Container, Col, Row } from "reactstrap";

const Functions = ({ functions, functionsDetailed }) => {
    return (
        <div className="core-features-bg">
            <Container>
                <p className="header-detased text-white text-left">Functions</p>
                {!!functionsDetailed ? functionsDetailed.map(res => (<p key={res} className="text-white" style={{ textAlign: "left" }}>{res}</p>)) : ""}
                <Row className="features-align">
                    {functions.map((res) => (
                        <Col md="4" key={res[0]}>
                            <p className="core-header" style={{ textAlign: "left" }}>
                                {res[0]}
                            </p>
                            <ul className="core-lists">
                                {res[1].map((res2) => (
                                    <li style={{ textAlign: "left" }}>{res2}</li>
                                ))}
                            </ul>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}

export default Functions;
